import { IAllocation, IAllocationDetails, IAllocationLog, IServiceGroup } from "../types/allocation";
import { apiClient } from "./client";

export const Allocation = {
  // Get allocations by project (grouped by service)
  getByProject: async (projectId: string): Promise<IServiceGroup[]> => {
    const response = await apiClient.get<IServiceGroup[]>(`/allocations/project/${projectId}`);
    return response.data;
  },

  // Get all allocations (optionally filtered by project)
  getAll: async (projectId?: string): Promise<IAllocation[]> => {
    const url = projectId ? `/allocations?projectId=${projectId}` : '/allocations';
    const response = await apiClient.get<IAllocation[]>(url);
    return response.data;
  },

  // Get single allocation by ID
  getById: async (allocationId: string): Promise<IAllocation> => {
    const response = await apiClient.get<IAllocation>(`/allocations/${allocationId}`);
    return response.data;
  },

  // Create new allocation
  create: async (data: Partial<IAllocation>): Promise<IAllocation> => {
    const response = await apiClient.post<IAllocation>('/allocations', data);
    return response.data;
  },

  // Update allocation
  update: async (allocationId: string, data: Partial<IAllocation>): Promise<IAllocation> => {
    const response = await apiClient.patch<IAllocation>(`/allocations/${allocationId}`, data);
    return response.data;
  },

  // Delete allocation
  delete: async (allocationId: string): Promise<IAllocation> => {
    const response = await apiClient.delete<IAllocation>(`/allocations/${allocationId}`);
    return response.data;
  },

  // Assign allocation to user
  assignToUser: async (allocationId: string, userId: string): Promise<IAllocation> => {
    const response = await apiClient.put<IAllocation>(`/allocations/${allocationId}/assign`, { userId });
    return response.data;
  },

  // Update allocation status
  updateStatus: async (allocationId: string, status: string): Promise<IAllocation> => {
    const response = await apiClient.put<IAllocation>(`/allocations/${allocationId}/status`, { status });
    return response.data;
  },

  // Form Data Management
  submitFormData: async (allocationId: string, formData: any, status: string): Promise<any> => {
    const response = await apiClient.post<any>(`/allocations/${allocationId}/form`, { formData, status });
    return response.data;
  },

  getFormData: async (allocationId: string): Promise<any> => {
    const response = await apiClient.get<any>(`/allocations/${allocationId}/form-data`);
    return response.data;
  },

  // Allocation Logs Management
  getLogs: async (allocationId: string): Promise<IAllocationLog[]> => {
    const response = await apiClient.get<IAllocationLog[]>(`/allocations/${allocationId}/logs`);
    return response.data;
  },

  getProjectLogs: async (projectId: string): Promise<IAllocationLog[]> => {
    const response = await apiClient.get<IAllocationLog[]>(`/allocations/project/${projectId}/logs`);
    return response.data;
  },

  createLog: async (logData: {
    allocationId: string;
    actionType: string;
    actionDescription?: string;
    metadata?: any;
  }): Promise<IAllocationLog> => {
    const response = await apiClient.post<IAllocationLog>('/allocations/time/logs', logData);
    return response.data;
  },

  // Get comprehensive allocation details
  getDetails: async (allocationId: string): Promise<IAllocationDetails> => {
    const response = await apiClient.get<IAllocationDetails>(`/allocations/${allocationId}`);
    return response.data;
  },
}